import { useEffect } from 'react';
import { useFomaularioStorage } from '../../storage';

// Toast simples em CSS puro (substitui o Snackbar do MUI). Mesma API: notify('msg').
export function notify(title) {
    const setOpenNotify = useFomaularioStorage.getState().dispatch.setOpenNotify;
    setOpenNotify({ open: false, title: '' });
    setOpenNotify({ open: true, title });
}

export default function NotifyComp() {
    const setOpenNotify = useFomaularioStorage.getState().dispatch.setOpenNotify;
    const { openNotify } = useFomaularioStorage(state => state.dados);

    useEffect(() => {
        if (!openNotify.open) return;
        const t = setTimeout(() => setOpenNotify({ open: false, title: '' }), 3000);
        return () => clearTimeout(t);
    }, [openNotify.open, openNotify.title, setOpenNotify]);

    return (
        <div style={wrap}>
            <div
                style={{
                    ...toast,
                    transform: openNotify.open ? 'translateY(0)' : 'translateY(-140%)',
                    opacity: openNotify.open ? 1 : 0,
                }}
                onClick={() => setOpenNotify({ open: false, title: '' })}
                role="status"
            >
                {openNotify.title}
            </div>
        </div>
    );
}

const wrap = {
    position: 'fixed', top: 20, left: 0, right: 0,
    display: 'flex', justifyContent: 'center',
    zIndex: 9999, pointerEvents: 'none',
};
const toast = {
    pointerEvents: 'auto', cursor: 'pointer',
    background: '#16161a', color: '#fff',
    padding: '12px 20px', borderRadius: 10,
    fontSize: 14, fontWeight: 600, maxWidth: '90vw',
    boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
    fontFamily: "'Inter', sans-serif",
    transition: 'transform .28s cubic-bezier(.2,.8,.2,1), opacity .28s',
};
